
















































import Vue, { PropType } from "vue";
import Map from "ol/Map.js";
import View from "ol/View.js";
import Overlay from "ol/Overlay";
import { Coordinate } from "ol/coordinate";
import { Extent } from "ol/extent";
import OlGridDataLayer from "./OlGridDataLayer.vue";
import OlMuniDataLayer from "./OlMuniDataLayer.vue";
import OlMuniBasemapLayer from "./OlMuniBasemapLayer.vue";
import GridFeaturePopup from "./GridFeaturePopup.vue";
import MuniFeaturePopup from "./MuniFeaturePopup.vue";
import LoadingAnimation from "./LoadingAnimation.vue";
import Legend from "./Legend.vue";
import { Pollutant, MapDataType, MuniFeatureProperties } from "@/types";
import { PollutantLegend } from "../types";
import Projection from "ol/proj/Projection";

const projection = new Projection({
  code: "EPSG:3067",
  extent: [50199.4814, 6582464.0358, 761274.6247, 7799839.8902],
  global: false,
  metersPerUnit: 1
});

export default Vue.extend({
  components: {
    OlGridDataLayer,
    OlMuniDataLayer,
    OlMuniBasemapLayer,
    GridFeaturePopup,
    MuniFeaturePopup,
    LoadingAnimation,
    Legend
  },
  props: {
    year: Number,
    gnfrId: String,
    pollutant: { type: Object as PropType<Pollutant | undefined> },
    mapDataType: { type: String as PropType<MapDataType> }
  },
  data() {
    return {
      map: undefined as Map | undefined,
      isReady: false as boolean,
      mapDataTypes: Object(MapDataType),
      overlay: null as Overlay | null,
      popupCoords: undefined as Coordinate | undefined,
      gridPopupValue: null as number | null,
      muniPopupVisible: false as boolean,
      muniPopupLoading: false as boolean,
      muniPopupFeat: null as MuniFeatureProperties | null,
      legend: undefined as PollutantLegend | undefined
    };
  },
  watch: {
    year() {
      this.handlePopupOnLayerChange();
    },
    gnfrId() {
      this.handlePopupOnLayerChange();
    },
    pollutant() {
      this.handlePopupOnLayerChange();
    }
  },
  methods: {
    handlePopupOnLayerChange() {
      if (this.mapDataType === MapDataType.GRID) {
        this.closePopup();
      } else {
        // a popup update is triggered in muni data layer, thus set loading=true
        this.muniPopupFeat = null;
        this.muniPopupLoading = true;
      }
    },
    updateLegend(legend: PollutantLegend) {
      this.legend = legend;
    },
    initializePopup() {
      this.overlay = new Overlay({
        // @ts-ignore
        element: this.$refs.olpopup, // popup tag, in html
        autoPan: true, // If the pop-up window is at the edge of the base image, the base image will move
        autoPanAnimation: {
          // Basemap moving animation
          duration: 250
        }
      });
      if (this.map) {
        this.map.addOverlay(this.overlay);
      }
    },
    setGridFeaturePopup(coordinate: Coordinate | undefined, value: number | null) {
      this.gridPopupValue = value;
      setTimeout(() => {
        // Set the timer here, otherwise the pop-up window will appear for the first time, and the base map will be off-track
        if (this.overlay) {
          this.overlay.setPosition(coordinate);
          this.popupCoords = coordinate;
        }
      }, 0);
    },
    setMuniFeaturePopup(
      coordinate: Coordinate | undefined,
      value: MuniFeatureProperties | null
    ) {
      this.muniPopupFeat = value;
      this.muniPopupVisible = value ? true : false;
      setTimeout(() => {
        if (this.overlay) {
          this.overlay.setPosition(coordinate);
          this.popupCoords = coordinate;
          this.muniPopupLoading = false;
        }
      }, 0);
    },
    closePopup() {
      // Set the position of the pop-up window to undefined, and clear the coordinate data
      if (this.overlay) {
        this.overlay.setPosition(undefined);
      }
      this.muniPopupVisible = false;
      this.popupCoords = undefined;
      this.gridPopupValue = null;
      this.muniPopupFeat = null;
    }
  },
  mounted() {
    this.map = new Map({
      target: "ol-map",
      layers: [],
      view: new View({
        projection,
        center: [435385.0836878328, 7247696.528687431],
        extent: [-166488.7651729983, 6568916.617733785, 1037258.9325486642, 7903739.064762917],
        zoom: 1.5
      })
    });
    this.map.once("postrender", () => {
      this.isReady = true;
      const extent = [
        -32010.40984326898,
        6590316.535987211,
        902780.5772189347,
        7905076.52138765
      ] as Extent;
      this.map!.getView().fit(extent, { padding: [15, 0, 0, 0] });
    });
    this.initializePopup();
    console.log("map", this.map);
  }
});
